document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tab-slider-swiper").forEach(function (sliderEl) {
    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      effect: "fade", // 🔥 smooth fade animation
      fadeEffect: {
        crossFade: true
      },
      speed: 800, // animation duration in ms
      pagination: {
        el: sliderEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: sliderEl.querySelector(".swiper-button-next"),
        prevEl: sliderEl.querySelector(".swiper-button-prev"),
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      }
    });
  });
});
